/**
 * The types of banner card.
 *
 * @class BannerCardTypes
 * @name types
 * @memberof Mojito.Modules.EventCards.Banner
 */
export default class BannerCardTypes {}

/**
 * An enumeration defining the theming modes available for the banner component.
 *
 * @enum {string}
 * @readonly
 * @memberof Mojito.Modules.EventCards.Banner.types
 */
BannerCardTypes.BANNER_CARD_MODES = {
    LIGHT: 'light',
    DARK: 'dark',
};

/**
 * Card banner details.
 *
 * @typedef CardBannerDetails
 * @type {object}
 *
 * @property {string} [headlineText] - Headline text.
 * @property {string} [primaryText] - Primary text.
 * @property {string} [secondaryText] - Secondary text.
 * @property {object} [primaryButton] - Data for primary button.
 * @property {string} [primaryButton.text] - Primary button text.
 * @property {string} [primaryButton.link] - Primary button link.
 * @property {object} [secondaryButton] - Data for primary button.
 * @property {string} [secondaryButton.text] - Secondary button text.
 * @property {string} [secondaryButton.link] - Secondary button link.
 * @property {Mojito.Modules.EventCards.Banner.types.BANNER_CARD_MODES} [colorMode] - Banner card color mode.
 *
 * @memberof Mojito.Modules.EventCards.Banner.types
 */
